export { default as TomIcon3P } from "./TomIcon3P";
export { default as TomIconAccessTime } from "./TomIconAccessTime";
export { default as TomIconAccountCircle } from "./TomIconAccountCircle";
export { default as TomIconAdd } from "./TomIconAdd";
export { default as TomIconAddCard } from "./TomIconAddCard";
export { default as TomIconAliexpress } from "./TomIconAliexpress";
export { default as TomIconAlternateEmail } from "./TomIconAlternateEmail";
export { default as TomIconAmericanExpress } from "./TomIconAmericanExpress";
export { default as TomIconApple } from "./TomIconApple";
export { default as TomIconArrowBack } from "./TomIconArrowBack";
export { default as TomIconArrowDownLeft } from "./TomIconArrowDownLeft";
export { default as TomIconArrowDownRight } from "./TomIconArrowDownRight";
export { default as TomIconArrowDownward } from "./TomIconArrowDownward";
export { default as TomIconArrowForward } from "./TomIconArrowForward";
export { default as TomIconArrowUpward } from "./TomIconArrowUpward";
export { default as TomIconAttachMoney } from "./TomIconAttachMoney";
export { default as TomIconAudioDown } from "./TomIconAudioDown";
export { default as TomIconAudioUp } from "./TomIconAudioUp";
export { default as TomIconAura } from "./TomIconAura";
export { default as TomIconBlock } from "./TomIconBlock";
export { default as TomIconBoleto } from "./TomIconBoleto";
export { default as TomIconCaixa } from "./TomIconCaixa";
export { default as TomIconCalendarToday } from "./TomIconCalendarToday";
export { default as TomIconCall } from "./TomIconCall";
export { default as TomIconCancel } from "./TomIconCancel";
export { default as TomIconCartaoLuiza } from "./TomIconCartaoLuiza";
export { default as TomIconCartaoLuizaGold } from "./TomIconCartaoLuizaGold";
export { default as TomIconCartaoMagalu } from "./TomIconCartaoMagalu";
export { default as TomIconCashback } from "./TomIconCashback";
export { default as TomIconCategoryAf } from "./TomIconCategoryAf";
export { default as TomIconCategoryAm } from "./TomIconCategoryAm";
export { default as TomIconCategoryAr } from "./TomIconCategoryAr";
export { default as TomIconCategoryAu } from "./TomIconCategoryAu";
export { default as TomIconCategoryBb } from "./TomIconCategoryBb";
export { default as TomIconCategoryBr } from "./TomIconCategoryBr";
export { default as TomIconCategoryBs } from "./TomIconCategoryBs";
export { default as TomIconCategoryCf } from "./TomIconCategoryCf";
export { default as TomIconCategoryCi } from "./TomIconCategoryCi";
export { default as TomIconCategoryCj } from "./TomIconCategoryCj";
export { default as TomIconCategoryCm } from "./TomIconCategoryCm";
export { default as TomIconCategoryCo } from "./TomIconCategoryCo";
export { default as TomIconCategoryCp } from "./TomIconCategoryCp";
export { default as TomIconCategoryCr } from "./TomIconCategoryCr";
export { default as TomIconCategoryDe } from "./TomIconCategoryDe";
export { default as TomIconCategoryEa } from "./TomIconCategoryEa";
export { default as TomIconCategoryEd } from "./TomIconCategoryEd";
export { default as TomIconCategoryEp } from "./TomIconCategoryEp";
export { default as TomIconCategoryEs } from "./TomIconCategoryEs";
export { default as TomIconCategoryEt } from "./TomIconCategoryEt";
export { default as TomIconCategoryFj } from "./TomIconCategoryFj";
export { default as TomIconCategoryFm } from "./TomIconCategoryFm";
export { default as TomIconCategoryFs } from "./TomIconCategoryFs";
export { default as TomIconCategoryGa } from "./TomIconCategoryGa";
export { default as TomIconCategoryIm } from "./TomIconCategoryIm";
export { default as TomIconCategoryIn } from "./TomIconCategoryIn";
export { default as TomIconCategoryLi } from "./TomIconCategoryLi";
export { default as TomIconCategoryMd } from "./TomIconCategoryMd";
export { default as TomIconCategoryMe } from "./TomIconCategoryMe";
export { default as TomIconCategoryMo } from "./TomIconCategoryMo";
export { default as TomIconCategoryMs } from "./TomIconCategoryMs";
export { default as TomIconCategoryNa } from "./TomIconCategoryNa";
export { default as TomIconCategoryPa } from "./TomIconCategoryPa";
export { default as TomIconCategoryPe } from "./TomIconCategoryPe";
export { default as TomIconCategoryPf } from "./TomIconCategoryPf";
export { default as TomIconCategoryPi } from "./TomIconCategoryPi";
export { default as TomIconCategoryRe } from "./TomIconCategoryRe";
export { default as TomIconCategoryRg } from "./TomIconCategoryRg";
export { default as TomIconCategorySa } from "./TomIconCategorySa";
export { default as TomIconCategorySe } from "./TomIconCategorySe";
export { default as TomIconCategoryTb } from "./TomIconCategoryTb";
export { default as TomIconCategoryTe } from "./TomIconCategoryTe";
export { default as TomIconCategoryTf } from "./TomIconCategoryTf";
export { default as TomIconCategoryUd } from "./TomIconCategoryUd";
export { default as TomIconChat } from "./TomIconChat";
export { default as TomIconChatBubbleOutline } from "./TomIconChatBubbleOutline";
export { default as TomIconChatSuccess } from "./TomIconChatSuccess";
export { default as TomIconChatWarning } from "./TomIconChatWarning";
export { default as TomIconCheck } from "./TomIconCheck";
export { default as TomIconCheckCircle } from "./TomIconCheckCircle";
export { default as TomIconCheckMagaluIndica } from "./TomIconCheckMagaluIndica";
export { default as TomIconChevronDown } from "./TomIconChevronDown";
export { default as TomIconChevronLeft } from "./TomIconChevronLeft";
export { default as TomIconChevronRight } from "./TomIconChevronRight";
export { default as TomIconChevronUp } from "./TomIconChevronUp";
export { default as TomIconClose } from "./TomIconClose";
export { default as TomIconCompraInternacional } from "./TomIconCompraInternacional";
export { default as TomIconContactSupport } from "./TomIconContactSupport";
export { default as TomIconContentCopy } from "./TomIconContentCopy";
export { default as TomIconCreditCard } from "./TomIconCreditCard";
export { default as TomIconCupom } from "./TomIconCupom";
export { default as TomIconCupomJourney } from "./TomIconCupomJourney";
export { default as TomIconCustomerContact } from "./TomIconCustomerContact";
export { default as TomIconDelete } from "./TomIconDelete";
export { default as TomIconDeliverySuccess } from "./TomIconDeliverySuccess";
export { default as TomIconDeliveryWarning } from "./TomIconDeliveryWarning";
export { default as TomIconDenuncia } from "./TomIconDenuncia";
export { default as TomIconDinners } from "./TomIconDinners";
export { default as TomIconDiscount } from "./TomIconDiscount";
export { default as TomIconDoisCartoes } from "./TomIconDoisCartoes";
export { default as TomIconElo } from "./TomIconElo";
export { default as TomIconEmail } from "./TomIconEmail";
export { default as TomIconEmojiEvents } from "./TomIconEmojiEvents";
export { default as TomIconEntrega2Dias } from "./TomIconEntrega2Dias";
export { default as TomIconEpoca } from "./TomIconEpoca";
export { default as TomIconErrorOutline } from "./TomIconErrorOutline";
export { default as TomIconExchange } from "./TomIconExchange";
export { default as TomIconFacebook } from "./TomIconFacebook";
export { default as TomIconFactCheck } from "./TomIconFactCheck";
export { default as TomIconFaleComLojista } from "./TomIconFaleComLojista";
export { default as TomIconFavorite } from "./TomIconFavorite";
export { default as TomIconFavoriteBorder } from "./TomIconFavoriteBorder";
export { default as TomIconFileDownload } from "./TomIconFileDownload";
export { default as TomIconFileUpload } from "./TomIconFileUpload";
export { default as TomIconFilterList } from "./TomIconFilterList";
export { default as TomIconFull } from "./TomIconFull";
export { default as TomIconGoogle } from "./TomIconGoogle";
export { default as TomIconGuarantee } from "./TomIconGuarantee";
export { default as TomIconGuaranteeFilled } from "./TomIconGuaranteeFilled";
export { default as TomIconHeadsetMic } from "./TomIconHeadsetMic";
export { default as TomIconHelpOutline } from "./TomIconHelpOutline";
export { default as TomIconHighlightOff } from "./TomIconHighlightOff";
export { default as TomIconHipercard } from "./TomIconHipercard";
export { default as TomIconHistory } from "./TomIconHistory";
export { default as TomIconHome } from "./TomIconHome";
export { default as TomIconImage } from "./TomIconImage";
export { default as TomIconInfo } from "./TomIconInfo";
export { default as TomIconInstagram } from "./TomIconInstagram";
export { default as TomIconInventory } from "./TomIconInventory";
export { default as TomIconIosShare } from "./TomIconIosShare";
export { default as TomIconKitchen } from "./TomIconKitchen";
export { default as TomIconLinkedin } from "./TomIconLinkedin";
export { default as TomIconList } from "./TomIconList";
export { default as TomIconLoaderColorFull } from "./TomIconLoaderColorFull";
export { default as TomIconLoaderColorLess } from "./TomIconLoaderColorLess";
export { default as TomIconLocalMall } from "./TomIconLocalMall";
export { default as TomIconLocalOfferOutline } from "./TomIconLocalOfferOutline";
export { default as TomIconLocalPolice } from "./TomIconLocalPolice";
export { default as TomIconLocalShipping } from "./TomIconLocalShipping";
export { default as TomIconLocalShippingFilled } from "./TomIconLocalShippingFilled";
export { default as TomIconLocationFilled } from "./TomIconLocationFilled";
export { default as TomIconLocationOn } from "./TomIconLocationOn";
export { default as TomIconLockerFilled } from "./TomIconLockerFilled";
export { default as TomIconLockerOutline } from "./TomIconLockerOutline";
export { default as TomIconLuizaCard } from "./TomIconLuizaCard";
export { default as TomIconMagalu } from "./TomIconMagalu";
export { default as TomIconMagaluFull } from "./TomIconMagaluFull";
export { default as TomIconMagaluRecommend } from "./TomIconMagaluRecommend";
export { default as TomIconMail } from "./TomIconMail";
export { default as TomIconMailOpen } from "./TomIconMailOpen";
export { default as TomIconMastercard } from "./TomIconMastercard";
export { default as TomIconMenu } from "./TomIconMenu";
export { default as TomIconMercado } from "./TomIconMercado";
export { default as TomIconMercadoFull } from "./TomIconMercadoFull";
export { default as TomIconMobilePhone } from "./TomIconMobilePhone";
export { default as TomIconMoreHoriz } from "./TomIconMoreHoriz";
export { default as TomIconMoreVert } from "./TomIconMoreVert";
export { default as TomIconMyLocation } from "./TomIconMyLocation";
export { default as TomIconNetshoesCircle } from "./TomIconNetshoesCircle";
export { default as TomIconNotifications } from "./TomIconNotifications";
export { default as TomIconNotificationsActive } from "./TomIconNotificationsActive";
export { default as TomIconNotificationsAdd } from "./TomIconNotificationsAdd";
export { default as TomIconOpenInNew } from "./TomIconOpenInNew";
export { default as TomIconPackageAlert } from "./TomIconPackageAlert";
export { default as TomIconPedido } from "./TomIconPedido";
export { default as TomIconPeople } from "./TomIconPeople";
export { default as TomIconPeopleOutline } from "./TomIconPeopleOutline";
export { default as TomIconPerson } from "./TomIconPerson";
export { default as TomIconPersonOutline } from "./TomIconPersonOutline";
export { default as TomIconPhoneInTalk } from "./TomIconPhoneInTalk";
export { default as TomIconPinterest } from "./TomIconPinterest";
export { default as TomIconPix } from "./TomIconPix";
export { default as TomIconPlace } from "./TomIconPlace";
export { default as TomIconPlayArrow } from "./TomIconPlayArrow";
export { default as TomIconPlayCircle } from "./TomIconPlayCircle";
export { default as TomIconPrivacyPolicy } from "./TomIconPrivacyPolicy";
export { default as TomIconQuestionAnswer } from "./TomIconQuestionAnswer";
export { default as TomIconReceipt } from "./TomIconReceipt";
export { default as TomIconRegulatory } from "./TomIconRegulatory";
export { default as TomIconRemove } from "./TomIconRemove";
export { default as TomIconReplyAll } from "./TomIconReplyAll";
export { default as TomIconRetiraLoja } from "./TomIconRetiraLoja";
export { default as TomIconSearch } from "./TomIconSearch";
export { default as TomIconServiceBabyShower } from "./TomIconServiceBabyShower";
export { default as TomIconServiceConsortium } from "./TomIconServiceConsortium";
export { default as TomIconServiceControlPlan } from "./TomIconServiceControlPlan";
export { default as TomIconServiceEmpMagalu } from "./TomIconServiceEmpMagalu";
export { default as TomIconServiceGoldClient } from "./TomIconServiceGoldClient";
export { default as TomIconServiceHouseSecurity } from "./TomIconServiceHouseSecurity";
export { default as TomIconServiceLuizaseg } from "./TomIconServiceLuizaseg";
export { default as TomIconServiceMarketplace } from "./TomIconServiceMarketplace";
export { default as TomIconServiceMarriage } from "./TomIconServiceMarriage";
export { default as TomIconServicePartner } from "./TomIconServicePartner";
export { default as TomIconServiceSmartHouse } from "./TomIconServiceSmartHouse";
export { default as TomIconSettings } from "./TomIconSettings";
export { default as TomIconShare } from "./TomIconShare";
export { default as TomIconShoppingBag } from "./TomIconShoppingBag";
export { default as TomIconShoppingBagFast } from "./TomIconShoppingBagFast";
export { default as TomIconShoppingBagFilled } from "./TomIconShoppingBagFilled";
export { default as TomIconStar } from "./TomIconStar";
export { default as TomIconStarBorder } from "./TomIconStarBorder";
export { default as TomIconStarHalf } from "./TomIconStarHalf";
export { default as TomIconStarHalfFilled } from "./TomIconStarHalfFilled";
export { default as TomIconStoreMallDirectory } from "./TomIconStoreMallDirectory";
export { default as TomIconStorefront } from "./TomIconStorefront";
export { default as TomIconSumarizacaoIa } from "./TomIconSumarizacaoIa";
export { default as TomIconSupportAgent } from "./TomIconSupportAgent";
export { default as TomIconSync } from "./TomIconSync";
export { default as TomIconTelevision } from "./TomIconTelevision";
export { default as TomIconThumbUp } from "./TomIconThumbUp";
export { default as TomIconTiktok } from "./TomIconTiktok";
export { default as TomIconTrendingDown } from "./TomIconTrendingDown";
export { default as TomIconTwitter } from "./TomIconTwitter";
export { default as TomIconTwitterX } from "./TomIconTwitterX";
export { default as TomIconValeCompra } from "./TomIconValeCompra";
export { default as TomIconVerified } from "./TomIconVerified";
export { default as TomIconVerifiedUser } from "./TomIconVerifiedUser";
export { default as TomIconVisa } from "./TomIconVisa";
export { default as TomIconVolunteerActivism } from "./TomIconVolunteerActivism";
export { default as TomIconVolunteerActivismOutline } from "./TomIconVolunteerActivismOutline";
export { default as TomIconWallet } from "./TomIconWallet";
export { default as TomIconWarningAmber } from "./TomIconWarningAmber";
export { default as TomIconWhatsapp } from "./TomIconWhatsapp";
export { default as TomIconWhatsappShare } from "./TomIconWhatsappShare";
export { default as TomIconYoutube } from "./TomIconYoutube";
export { default as TomIconZattini } from "./TomIconZattini";
//# sourceMappingURL=index.js.map